/* eslint-disable react/no-array-index-key */
import React from "react";
import { IProduct } from "../../../types";
import "./LineItem.scss";
import { getTotalAmountForLineItem, getVatAmountForLineItem } from "../../../utils/Calculation";
import { IMoreOption, IMoreOptionItem } from "../../../components";
import { numberWithSpaces } from "../../../utils/utils";

export interface LineItemDisplayProps {
  lineItemInformation: Array<IProduct> | [];
  onEditLineItem: any;
  onDeleteLineItem: any;
  onLineItemSelect: any;
}

const LineItemDisplay = ({ onLineItemSelect, lineItemInformation, onEditLineItem, onDeleteLineItem }: LineItemDisplayProps) => {
  const menuItems: Array<IMoreOptionItem> = [
    { name: "Edit", onClick: onEditLineItem },
    { name: "Delete", onClick: onDeleteLineItem },
  ];
  return (
    <>
      {lineItemInformation && lineItemInformation.length > 0 && (
        <div className="line-item-container text-bold text-size-16">
          <div className="line-item heading">Item Name</div>
          <div className="line-item heading">Description</div>
          <div className="line-item heading">Qty</div>
          <div className="line-item heading">VAT</div>
          <div className="line-item heading">Price (incl. VAT)</div>
        </div>
      )}
      {lineItemInformation &&
        lineItemInformation.map((lineItem: IProduct, index: number) => {
          const totalItemPrice = getTotalAmountForLineItem(lineItem);
          const totalItemVAT = getVatAmountForLineItem(lineItem);
          return (
            <div key={index}>
              <div className="mobile-line-item-container p-2 mt-3" key={`mobile_${index}`}>
                <div className="d-flex justify-content-between align-items-center ">
                  <div className="text text-bold text-size-18">{lineItem.itemName}</div>
                  <IMoreOption options={menuItems} onClick={() => onLineItemSelect(index)} />
                </div>
                <div className="text pb-3 text-size-16">{lineItem.description}</div>
                <div className="d-flex justify-content-between">
                  <div className="text">Qty: {numberWithSpaces(lineItem.lineItemQuantity)}</div>
                  <div className="text">R {numberWithSpaces(lineItem.price)} (incl. VAT)</div>
                </div>
              </div>
              {/* desktop */}
              <div key={`desktop_${index}`}>
                <div className="line-item-container mt-1">
                  <div className="line-item name">{lineItem.itemName}</div>
                  <div className="line-item description">{lineItem.description}</div>
                  <div className="line-item quantity">{numberWithSpaces(lineItem.lineItemQuantity)}</div>
                  <div className="line-item vat">R&nbsp;{numberWithSpaces(totalItemVAT.toFixed(2))}</div>
                  <div className="line-item price text-bold">R&nbsp;{numberWithSpaces(totalItemPrice.toFixed(2))}</div>
                  <div>
                    <IMoreOption options={menuItems} onClick={() => onLineItemSelect(index)} />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default LineItemDisplay;
